module.exports = __webpack_public_path__ + "admin/img/ibobee_logo.72861e16.png";